const APIS = {
  FILE_HANDLER: '/driveservice/api/file/',
  GENERATE_QR: '/driveservice/api/generate-qr/',
};
export default APIS;
